const API_BASE = 'https://dublin-meter-swap.carlsapp.com/api';
const STORAGE_KEY = 'MeterData';
const WINDOW_TITLE = 'Dublin Meter Swap';
const APP_VERSION = '2.8';

// To use this file in a CommonJS environment replace export with module.exports =.
export {
    API_BASE, STORAGE_KEY, WINDOW_TITLE, APP_VERSION,
};
